import useSWR, { SWRConfiguration } from 'swr'
import SWR_KEY from './constant'
import { tokenService } from 'services'
import { FiatType, TokenType, useTokenStore } from 'state/useTokenStore'
import { formatUnits } from 'utils'

export const useGetTokenList = (configs?: SWRConfiguration) => {
	const tokenList = useTokenStore((s) => s.tokenList)
	const setTokenList = useTokenStore((s) => s.setTokenList)
	const setTokenFrom = useTokenStore((s) => s.setTokenFrom)
	const tokenFrom = useTokenStore((s) => s.tokenFrom)

	const fetchData = async () => await tokenService.getList().then(({ data }) => {
		const { data: list } = data

		const formatData = (list as TokenType[]).map(item => ({
			...item,
			rate: formatUnits(item.price, +item.decimals),
			logo: process.env.REACT_APP_API_STORE + item.logo
		}))

		setTokenList(formatData)

		if (!tokenFrom) {
			const usdtToken = formatData.find(item => item.symbol === 'USDT')
			if (usdtToken) setTokenFrom(usdtToken)
		} else {
			const _token = formatData.find(item => item.symbol === tokenFrom.symbol)
			if (_token) setTokenFrom(_token)
		}

		return list
	})

	// return useSWR(!tokenList ? SWR_KEY.GET_TOKEN_LIST : null, fetchData, {
	// 	fallbackData: tokenList,
	// 	revalidateOnFocus: false,
	// 	...configs
	// })
	return useSWR(SWR_KEY.GET_TOKEN_LIST, fetchData, {
		fallbackData: tokenList,
		// revalidateOnFocus: false,
		...configs
	})
}

export const useGetFiatList = (configs?: SWRConfiguration) => {
	const fiatList = useTokenStore((s) => s.fiatList)
	const setFiatList = useTokenStore((s) => s.setFiatList)
	const setFiatTo = useTokenStore((s) => s.setFiatTo)

	const fetchData = async () => await tokenService.getFiatList().then(({ data }) => {
		const { data: list } = data

		const formatData = (list as FiatType[]).map(item => ({
			...item,
			logo: process.env.REACT_APP_API_STORE + item.image
		}))

		setFiatList(formatData)

		const vndFiat = formatData.find(item => item.name === 'VND')
		if (vndFiat) setFiatTo(vndFiat)

		return list
	})

	// return useSWR(!fiatList ? SWR_KEY.GET_FIAT_LIST : null, fetchData, {
	// 	fallbackData: fiatList,
	// 	revalidateOnFocus: false,
	// 	...configs
	// })
	return useSWR(SWR_KEY.GET_FIAT_LIST, fetchData, {
		fallbackData: fiatList,
		// revalidateOnFocus: false,
		...configs
	})
}

export const useGetAloWallet = (configs?: SWRConfiguration) => {
	return useSWR(SWR_KEY.GET_ALO_WALLET, tokenService.getAloWallet, {
		revalidateOnFocus: false,
		...configs
	})
}

export const useGetTokenWallet = (configs?: SWRConfiguration) => {
	return useSWR(SWR_KEY.GET_TOKEN_WALLET, tokenService.getAloWallet, {
		revalidateOnFocus: false,
		...configs
	})
}

export const useConvertAmount = (configs?: SWRConfiguration) => {
	return useSWR(SWR_KEY.CONVERT_AMOUNT, tokenService.getAloWallet, {
		revalidateOnFocus: false,
		...configs
	})
}
